import { forwardRef } from "react";
import * as React from "react";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";

import type { IInputProps } from "@/components/atoms/Input/types";
import cn from "@/helpers/cn";

import Input from "./input";

const SearchInput = forwardRef<HTMLInputElement, IInputProps>(
  ({ className, isProjectSearch, type, ...props }, ref) => {
    return (
      <div className={cn("relative max-w-lg", isProjectSearch && "max-w-full")}>
        <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 fill-current" />
        <Input
          type={type}
          className={cn(
            `flex w-full bg-accent max-w-lg h-12 rounded-xl px-8`,
            className,
          )}
          ref={ref}
          {...props}
        />
      </div>
    );
  },
);

SearchInput.displayName = "Search Input";

export default SearchInput;
